import i18n from '@/i18n'

const { t }: any = i18n.global

export default {
  name: [
    (v: any) => !!v || t('validationNameRequired'),
    (v: any) => (v && v.length < 255) || t('validationNameShorter')
  ],
  category_id: [
    (v: any) => !!v || t('validationRequired')
  ],
  rate: [
    (v: any) => (v !== null && v !== undefined && v !== '') || t('validationRequired')
  ],
  rate_type: [
    (v: any) => !!v || t('validationRequired')
  ],
  internal_article_number: [
    (v: any) => !!v || t('validationRequired'),
    (v: any) => (v && v.length >= 3 && v.length <= 12) || t('validationInternalArticleNumberLength'),
    (v: any) => (v && /^[A-Z0-9-]+$/.test(v)) || t('validationInternalArticleNumberFormat')
  ]
}
